import { useTranslation } from 'react-i18next';

export const useCountryOverrides = (overridePath, style) => {
  const { t } = useTranslation(['forms', 'overrides', ...(style ? [`${style}-views`] : [])]);
  const formCopy = t('formCopy', { returnObjects: true });
  const formCopyOverrides = t(`formCopy.${overridePath}`, { ns: 'overrides', returnObjects: true });
  const formCopyView = t(`formCopy.${overridePath}`, { ns: `${style}-views`, returnObjects: true });

  // formCopy is gotten above with the 'returnObjects' param, which will omit a missing property even if there's a fallback.
  // We don't have XTM support for languages such as en-NL, en-BE, and en-FR. So fallbacks are critical for these.
  ['autoOptIn', 'edit'].forEach((key) => {
    if (!formCopy[key]) {
      formCopy[key] = t(`formCopy.${key}`); // Add the fallback if it exists.
    }
  });

  // Country overrides
  if (!formCopyOverrides) {
    return formCopy;
  }
  Object.keys(formCopyOverrides).forEach((key) => {
    if (key === 'country') {
      formCopy.country.options = {
        ...formCopy.country.options,
        ...formCopyOverrides.country.options,
      };
    } else {
      formCopy[key] = formCopyOverrides[key];
    }
  });
  formCopy.country.label = formCopyOverrides?.country?.label || formCopy.country.label;

  // newsletterOpt overrides
  if (!formCopyView) {
    return formCopy;
  }
  Object.keys(formCopyView).forEach((key) => {
    if (key === 'newsletterOpt') {
      formCopy.newsletterOpt = formCopyView.newsletterOpt;
    }
  });

  return formCopy;
};
